export function assert(val: unknown, message = 'Assertion failed'): asserts val {
  if (!val) {
    throw new Error(message);
  }
}

export function checkExhaustive(val: never): never {
  throw new Error('Unexpected value: ' + val);
}